const proposalDocumentProviderApplication = Object.freeze({
  Nuevo: 0,
  Existente: 1,
  Ambos: 2,
});

export default proposalDocumentProviderApplication;
